module.exports = __webpack_public_path__ + "static/media/2.4d352039.JPG";